var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVisa = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M35 21.943C35 23.079 34.074 24 32.931 24H2.07C.926 24 0 23.079 0 21.943V2.057C0 .921.926 0 2.069 0H32.93C34.074 0 35 .921 35 2.057v19.886z",
    transform: "translate(-207.000000, -723.000000) translate(16.000000, 699.000000) translate(191.000000, 23.999961)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F79F1A",
    d: "M7.768 12.138l-.821-3.92c-.14-.54-.55-.701-1.06-.722H2.118l-.034.179c2.935.707 4.876 2.414 5.683 4.463z",
    transform: "translate(-207.000000, -723.000000) translate(16.000000, 699.000000) translate(191.000000, 23.999961)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#059BBF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.499 7.575L14.064 7.575 12.544 16.446 14.974 16.446zM9.252 16.438l3.829-8.857h-2.577l-2.381 6.05-.255-.913c-.467-1.099-1.801-2.68-3.367-3.677l2.177 7.4 2.574-.003zM23.443 13.546c.009-1.007-.642-1.775-2.044-2.41-.851-.41-1.37-.683-1.364-1.099 0-.367.44-.762 1.392-.762.797-.012 1.371.16 1.82.34l.22.1.33-1.922c-.483-.179-1.237-.37-2.18-.37-2.404 0-4.095 1.202-4.11 2.927-.016 1.275 1.209 1.986 2.13 2.41.947.434 1.265.711 1.259 1.1-.006.594-.754.865-1.454.865-.974 0-1.49-.133-2.29-.465l-.311-.142-.342 1.988c.568.247 1.618.462 2.708.471 2.556 0 4.217-1.187 4.236-3.03zM26.334 15.117l3.115.003c.073.309.296 1.33.296 1.33h2.257l-1.97-8.866h-1.878c-.583 0-1.016.158-1.273.734l-3.612 8.132h2.556s.415-1.093.51-1.333zm1.668-4.297c-.013.025.201-.513.323-.847l.165.765.562 2.563h-2.018c.201-.51.968-2.48.968-2.48zM32.931 0H2.07C.926 0 0 .921 0 2.057v2.135h35V2.057C35 .921 34.074 0 32.931 0z",
    transform: "translate(-207.000000, -723.000000) translate(16.000000, 699.000000) translate(191.000000, 23.999961)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F79F1A",
    d: "M32.931 24H2.07C.926 24 0 23.079 0 21.943v-2.135h35v2.135C35 23.079 34.074 24 32.931 24z",
    transform: "translate(-207.000000, -723.000000) translate(16.000000, 699.000000) translate(191.000000, 23.999961)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#202121",
    d: "M1.47 21.943V2.057C1.47.921 2.398 0 3.54 0H2.069C.926 0 0 .921 0 2.057v19.886C0 23.079.926 24 2.069 24H3.54c-1.143 0-2.07-.921-2.07-2.057z",
    opacity: 0.15,
    transform: "translate(-207.000000, -723.000000) translate(16.000000, 699.000000) translate(191.000000, 23.999961)"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVisa);
export { ForwardRef as ReactComponent };